// @flow
import { createSelector } from 'reselect';
import { getIdFromProps } from '../selectors';
import { getProductItems } from '~/core/state/products/selectors';
import { getIn, get } from '~/core/utils/immutable';
import Maybe from 'folktale/maybe';
import { get as pluck, flowRight, curry, some, identity } from 'lodash/fp';
import { stateIdentity } from '~/core/state/selectors';
import { getIsHueDevice } from '~/core/state/devices/selectors';

const map = curry((iteratee, functor) => functor.map(iteratee));

const getName = getIn(['state', 'name']);
const getConsumers = getIn(['props', 'consumers']);
const getIsGroup = get('isGroup');
const getId = get('id');
const getSaving = get('saving');
const pluckSize = pluck('size');
const pluckGroups = pluck('groups');

const ascending = (a, b) => a.localeCompare(b);
const byName = comparator => (a, b) => comparator(getName(a), getName(b));

const getGroups = flowRight(Maybe.fromNullable, pluckGroups);

export const getGroupItems = createSelector(getProductItems, prods =>
    Maybe.fromNullable(prods).map(prods => prods.filter(getIsGroup).sort(byName(ascending)))
);

export const getGroupById = createSelector(getIdFromProps, getGroupItems, (id, groups) =>
    groups.chain(groups => Maybe.fromNullable(groups.find(g => getId(g) === id)))
);

export const getGroupName = createSelector(getGroupById, map(getName));
export const getGroupConsumers = createSelector(getGroupById, map(getConsumers));
export const getGroupProductsCount = createSelector(getGroupConsumers, map(pluckSize));
export const getIsSaving = createSelector(getGroups, groups => groups.map(getSaving).getOrElse(false));

export const getGroupHasHueDevices = createSelector([getGroupConsumers, stateIdentity], (devices, state) =>
    map(devices => some(identity, devices.map(id => getIsHueDevice(state, { id })).toJS()), devices).getOrElse(false)
);



// WEBPACK FOOTER //
// ./src/core/state/groups/selectors.js